import '../stylesheets/title.css'

export const Title = () => {
  return (
    <div className="title">Weviews</div>
  );
}

